module.exports = __webpack_public_path__ + "img/quickship-truck.f95a0bce.jpg";